export enum LegSource {
  Shuttle,
  CustomShuttle,
  CrowdFunded,
  PrivateCharter,
  SharedCharter,
  OperatorPortalSharedCharter,
  OperatorPortalWholeCharter = 6,
}
